export const checkReadyToLoad = ({ props }) => {
  const {
    instructorData,
    isFetchingSetupLicenses,
    isFetchingActiveDigitalLicenses,
    isRefetching,
  } = props

  const readyToLoad =
    !instructorData?.Classes ||
    !instructorData?.MiddleSchool ||
    !instructorData?.Sela ||
    !instructorData?.HighSchool ||
    isFetchingActiveDigitalLicenses ||
    isFetchingSetupLicenses ||
    isRefetching

  return readyToLoad
}

export const formatTabName = tabName => {
  if (!tabName) return ''

  if (tabName === 'sel-for-adults') {
    // Second function logic
    return tabName
      .split('-') // Split by hyphen
      .map(word => {
        if (/^\d+$/.test(word)) {
          // If the word is a number, return it as is
          return word
        }
        // Otherwise, capitalize the first letter
        return word.charAt(0).toUpperCase() + word.slice(1)
      })
      .join(' ') // Join with spaces
      .replace(/(\d+) (\d+)/g, '$1-$2') // Reintroduce hyphens between numbers
  } else {
    // First function logic
    return tabName
      .replace('-', ' ') // Replace the first hyphen with a space
      .split(' ') // Split by spaces
      .map(word => {
        if (/^\d+$/.test(word)) {
          // If the word is a number, return it as is
          return word
        }
        // Otherwise, capitalize the first letter
        return word.charAt(0).toUpperCase() + word.slice(1)
      })
      .join(' ') // Join with spaces
  }
}
